import React from 'react';
import Heading from '@vfuk/core-heading';
import TextInputWithLabel from '@vfuk/core-text-input-with-label';
import { FirstQuestionProps } from '../../Types/FirstQuestion.types';
import { HeadingWrapper } from '../../styles/SectionAssessmentAboutBusiness.styles';
import fireAssessmentCommonEvents from '../../../../../../helpers/fireAssessmentCommonEvents';

const FirstQuestion = ({
  content,
  firstsetquestions,
  businessName,
  nextButtonDisabled,
  getQuestionImage,
  inputOnchange,
  goToNextSlide,
}: FirstQuestionProps) => {
  const onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!nextButtonDisabled) {
      goToNextSlide();
    }
  };

  const inputOnBlur = () => {
    if (businessName) {
      fireAssessmentCommonEvents(businessName);
    }
  };

  return (
    <div id="carouselItem" className="question1">
      <div>
        <img className="sureyQueImage" src={getQuestionImage(0)} />
      </div>

      <div className="questionStyle">
        {`${content.questionNumberText1} 1 ${content.questionNumberText2} ${
          firstsetquestions.length + 3
        }`}
      </div>

      <HeadingWrapper>
        <Heading
          text={content.firstQuestion.label}
          weight={2}
          size={2}
          noMargin={true}
        />
      </HeadingWrapper>

      <div className="formText">
        <form onSubmit={onFormSubmit}>
          <TextInputWithLabel
            fieldWrapper={{
              label: '',
              width: 'full',
            }}
            textInput={{
              type: 'text',
              id: 'firstAnswer',
              placeholder: content.firstQuestion.placeholder,
              value: businessName,
              onChange: inputOnchange,
              onBlur: inputOnBlur,
              dataAttributes: { 'data-testid': 'firstAnswer' },
              name: content.firstQuestion.name,
            }}
          />
        </form>
      </div>
    </div>
  );
};

export default FirstQuestion;
